import styled from "styled-components/macro"
import Color from "../../../constants/Color"
import { Link } from "react-router-dom"

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  background: linear-gradient(89.9deg, #000000 49.99%, rgba(0, 0, 0, 0) 99.91%),
    url(${({ path }) => path});
  background-size: cover;
  background-position: center;
  object-fit: cover;
  overflow: hidden;
`

export const BlurWrapper = styled.div`
  width: 100%;
  padding: 24px 16px;
  /* background: rgba(255, 255, 255, 0.6); */
  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(1px);

  @media (min-width: 1280px) {
    padding: 36px 16px;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    align-items: center;
    flex-direction: row;
  }

  @media (min-width: 1280px) {
    align-items: center;
    flex-direction: row;
  }
`
export const Year = styled.span`
  font-weight: 100;
`
export const Thumbnail = styled.div`
  display: none;
  min-width: 100%;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.8);
  border: 3px solid #fff;
  outline: none;
  overflow: hidden;

  @media (min-width: 640px) {
    display: block;
  }

  @media (min-width: 768px) {
    min-width: 328px;
    height: 480px;
  }
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: fill;
  color: transparent;
  outline: none;
`
export const Content = styled.div`
  padding: 14px 0px;
  flex: 1;

  @media (min-width: 768px) {
    padding: 0 20px;
  }
  @media (min-width: 1280px) {
    padding-left: 40px;
  }
`

export const Name = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${Color.gray50};
  margin-bottom: 4px;

  @media (min-width: 1280px) {
    font-size: 36px;
    margin-bottom: 6px;
    font-weight: 700;
  }
`

export const GContainer = styled.div`
  width: 100%;
  margin-bottom: 6px;
`

export const GLink = styled(Link)`
  display: inline-block;
  font-size: 14px;
  color: ${Color.gray200};
  text-decoration: none;
  margin-right: 6px;
  line-height: 18px;
  transition: color 0.3s ease-in-out;

  @media (min-width: 1280px) {
    font-size: 16px;
  }

  &::after {
    content: "•";
    font-size: 10px;
    margin-left: 6px;
  }

  &:last-child::after {
    content: "";
    margin-left: 0px;
  }

  &:hover {
    color: ${Color.gray300};
  }
`

export const TimeAndDate = styled.div`
  margin-bottom: 24px;
  display: flex;
`

export const IconWithText = styled.div`
  display: flex;
  align-items: center;
  color: ${Color.gray200};
  font-size: 12px;
  font-weight: bold;
  margin-right: 12px;

  @media (min-width: 1280px) {
    font-size: 14px;
  }

  & i {
    font-size: 16px;
    color: ${Color.gray200};
    margin-right: 4px;
  }

  &::after {
    content: "|";
    margin-left: 12px;
  }
  &:last-child::after {
    content: "";
  }
`

export const Paragraph = styled.p``

export const Title = styled.h4`
  color: ${Color.gray50};
  font-size: 16px;
  margin-bottom: 8px;

  @media (min-width: 1280px) {
    font-size: 20px;
  }
`

export const Text = styled.p`
  font-size: 14px;
  margin-bottom: 24px;
  color: ${Color.gray300};

  @media (min-width: 1280px) {
    width: 640px;
    font-size: 16px;
  }
`
